/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getEventId } from '@e180/domain/lib/event/util';

import OnboardingMainDumb from './OnboardingMainDumb';
import { completeOnboarding } from 'src/shared/app/onboarding/action/onboardingActions';
import { completeOnboardingOnDevice } from 'src/shared/app/onboarding/action/uiOnboardingActions';
import { markOnboardingAsCompletedInCookie } from 'src/shared/app/onboarding/util/onboardingUtils';
import { isLoginShownBeforeSignup } from 'plugin/signup/util/signupUtils';
import { isDevModeEnabled } from 'src/shared/app/base/selector/appEnvSelectors';
import withFeatureDecisions from 'src/shared/app/feature/component/withFeatureDecisions';
import { getRoutePath } from 'src/shared/app/base/route/util/routeUtils';
import {
  signupRoute,
  loginRoute,
} from 'src/shared/app/base/route/setting/routeSettings';
import { getAuthenticationToken } from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';
import { trackGAEvent } from 'src/shared/core/service/tracking/gaService';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  // Self passed
  history: Object,
  featureDecisions: Object,
};

const mapStateToProps = (state: State): Object => ({
  // Used in `mergeProps` only
  event: getEventSafely(state),
  token: getAuthenticationToken(state),
  isDevModeEnabled: isDevModeEnabled(state),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { history, featureDecisions }: Props,
): Object => {
  const { event, token, isDevModeEnabled } = stateProps;

  return {
    ...stateProps,
    handleOnboardingComplete: () => {
      trackGAEvent('Onboarding', 'Click next');

      markOnboardingAsCompletedInCookie(!isDevModeEnabled);

      dispatch(completeOnboardingOnDevice());

      if (token) {
        dispatch(completeOnboarding(getEventId(event)));
      } else {
        history.push(
          featureDecisions.isSignupEnabled() && !isLoginShownBeforeSignup(event)
            ? getRoutePath(signupRoute)
            : getRoutePath(loginRoute),
        );
      }
    },
  };
};

export default compose(
  withRouter,
  withFeatureDecisions,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(OnboardingMainDumb);
